import { Text } from '@shared/components';

interface RoomInfoProps {
  label: string;
  value: string | number;
}

export function RoomInfo(props: Readonly<RoomInfoProps>) {
  const { label, value } = props;

  return (
    <Text variant='body2Semibold' component='span'>
      {label}:
      <Text
        variant='body2'
        component='span'
        sx={(theme) => ({
          ml: theme.spacing(1),
        })}
      >
        {value}
      </Text>
    </Text>
  );
}
